import React, { Component } from 'react';
import Joyride, { EVENTS, ACTIONS } from 'react-joyride';
import WelcomeModal from './WelcomeModal';
import Tooltip from './Tooltip';

const steps = [
  {
    target: '.paycon-ftue-add-button',
    disableBeacon: true,
    placement: 'bottom-end',
    title: 'Add Configuration',
    content: 'Begin customizing your payment methods here.',
    spotlightClicks: true,
  },
  {
    target: '.paycon-ftue-form-name',
    disableBeacon: true,
    placement: 'bottom',
    title: 'Enter Configuration Name',
    content:
      'Naming your configurations allows you to easily identify them. Make sure names are unique for each custom configuration.',
  },
  {
    target: '.paycon-ftue-form-outlets',
    disableBeacon: true,
    placement: 'bottom',
    title: 'Assign Outlets',
    content:
      'Choose which outlets you would like to apply your custom configuration to.',
  },
  {
    target: '.paycon-ftue-checklist-section',
    disableBeacon: true,
    placement: 'top',
    title: 'Start Configuring',
    content:
      'Configure your payment methods by selecting which options you would like to disable or enable.',
  },
  {
    target: '.paycon-ftue-preview-button',
    disableBeacon: true,
    placement: 'top',
    title: 'Preview Configuration',
    content:
      'Once you are done configuring, you can preview how your MokaPOS app would look like with the changes applied.',
  },
  {
    target: '.paycon-ftue-save-button',
    disableBeacon: true,
    placement: 'top-end',
    title: 'Save Your Configuration',
    content: 'Make sure you save your configuration once you are done.',
  },
  {
    target: '.paycon-ftue-list tr:first-child',
    disableBeacon: true,
    placement: 'bottom',
    title: 'Default Configuration',
    content:
      'This is the current default configuration applied to your outlets where all payment methods are enabled.',
    locale: { last: 'Got it' },
  },
];

class PaymentConfigurationFtue extends Component {
  state = {
    showWelcomeModal: true,
    isTourRunning: false,
    stepIndex: 0,
    nextIndexAfterAnimation: -1,
  };

  handleWelcomeModalClose = () => {
    this.setState({
      showWelcomeModal: false,
      isTourRunning: true,
    });
  };

  componentDidUpdate(prevProps) {
    const { isFormOpen } = this.props;
    const { stepIndex, nextIndexAfterAnimation } = this.state;

    // After form opened or form closed
    if (prevProps.isFormOpen !== isFormOpen) {
      let nextIndex = nextIndexAfterAnimation;
      if (nextIndex < 0) {
        nextIndex = stepIndex + 1;
      }

      // Pause tour first
      this.setState({
        isTourRunning: false,
      });

      // Resume after animation ended
      setTimeout(() => {
        this.setState({
          isTourRunning: true,
          stepIndex: nextIndex,
        });
      }, 600);
    }
  }

  handleJoyrideCallback = joyrideData => {
    const {
      isFormOpen,
      onRequestFormOpen,
      onRequestFormClose,
      onFormTourComplete,
    } = this.props;
    const { stepIndex } = this.state;
    const { type: eventType, index, action } = joyrideData;

    // If close button is clicked, we are done (consider tour ends)
    if (action === ACTIONS.CLOSE) {
      this.setState({
        isTourRunning: false,
        stepIndex: 0,
      });
      onFormTourComplete();
      return;
    }

    if (eventType === EVENTS.STEP_AFTER) {
      // `stepIndex` is the index we want to go
      // `index` is the current index
      // If they are equal, then it is a normal 1-step move and we need to compute it
      let nextIndex = stepIndex;
      if (index === stepIndex) {
        if (action === ACTIONS.NEXT) {
          nextIndex++;
        } else if (action === ACTIONS.PREV) {
          nextIndex--;
        }
      }

      // Steps between 0 and 6 requires the form to be open
      const needFormOpen = nextIndex > 0 && nextIndex < 6;

      // If the required form state is different with what the next step demands,
      // we need to request a change.
      if (needFormOpen !== isFormOpen) {
        if (isFormOpen) {
          onRequestFormClose();
        } else {
          onRequestFormOpen();
        }
        this.setState({
          nextIndexAfterAnimation: nextIndex,
        });
      } else {
        this.setState({
          stepIndex: nextIndex,
          nextIndexAfterAnimation: -1,
        });
      }
    } else if (eventType === EVENTS.TOUR_END) {
      onFormTourComplete();
    }
  };

  handleJumpToStep = toIndex => {
    this.setState({
      stepIndex: toIndex,
    });
  };

  render() {
    const { showWelcomeModal, isTourRunning, stepIndex } = this.state;

    if (showWelcomeModal) {
      return <WelcomeModal onClose={this.handleWelcomeModalClose} />;
    }

    return (
      <Joyride
        disableScrolling
        disableScrollParentFix
        run={isTourRunning}
        continuous
        steps={steps}
        stepIndex={stepIndex}
        callback={this.handleJoyrideCallback}
        spotlightPadding={5}
        disableCloseOnEsc
        disableOverlayClose
        tooltipComponent={tooltipProps => (
          <Tooltip onJumpToStep={this.handleJumpToStep} {...tooltipProps} />
        )}
        floaterProps={{ disableAnimation: true, id: 'payconFtue' }}
        styles={{
          options: {
            arrowColor: '#4A4A4A',
          },
        }}
      />
    );
  }
}

export default PaymentConfigurationFtue;
